import { Map } from 'immutable';
import { ChannelStatus } from '../../dto';
import { ChannelStatusSnapshot } from '../../dto/SnapshotEnvelope';

export const channelStatusSnapshot = (snapshot: ChannelStatusSnapshot) => db =>
    db.setIn(
        ['turboLive', 'channelStatus'],
        Map(snapshot.statuses.map(channelStatus => [channelStatus.channelId, channelStatus.status]))
    );

export const channelStatusPush = (status: ChannelStatus) => db =>
    db.updateIn(['turboLive', 'channelStatus'], Map(), channelStatuses =>
        channelStatuses.set(status.channelId, status.status)
    );
